import * as React from 'react';
import { SearchCardsItem } from '../SearchCardsItem';
import { ISavedSearch } from '../../../../types/savedSearch';

import styles from './styles.css';

export interface ISavedSearchesListProps {
  savedSearches: ISavedSearch[];
  onSearchTitleChange(id: number, title: string): void;
  onSearchRemove(id: number): void;
}

export const SavedSearchesList: React.FC<ISavedSearchesListProps> = ({
  savedSearches,
  onSearchTitleChange,
  onSearchRemove,
}) => {
  return (
    <div className={styles['container']}>
      {savedSearches.map(item => (
        <SearchCardsItem
          {...item}
          key={`item_${item.id}`}
          onSave={title => onSearchTitleChange(item.id as number, title)}
          onRemove={() => onSearchRemove(item.id as number)}
        />
      ))}
    </div>
  );
};
